import axios from "axios";
export const GetPaymentUrlAndUserInfo = (data) => {

    return axios.post(process.env.REACT_APP_BACKEND_API+"/api/finance/easy-collect-intermediate/",data, {
      headers:{
        "Content-Type": "application/json"   
      }
    }
);
  };


